module.exports = __webpack_public_path__ + "media/assets/cardBookNowPlatinum-a1141f282184cb52c4d25c95e63e1e90.png";